/**
 * Shell global. Cabecera minimalista con botón "Inicio" que lleva al hub.
 * La navegación entre entornos se hace desde el hub (/hub).
 */
import { NavLink, Outlet } from "react-router-dom";
import { Home } from "lucide-react";

const AppShell = () => {
  return (
    <div className="min-h-screen flex flex-col w-full">
      <div className="h-12 flex items-center gap-1 border-b bg-background/80 backdrop-blur px-3 sticky top-0 z-30">
        <NavLink
          to="/hub"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-brand-foreground bg-brand hover:bg-brand/90 hover:shadow-sm transition-all"
          title="Volver al inicio"
        >
          <Home className="h-4 w-4" />
          Inicio
        </NavLink>
      </div>
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
};

export default AppShell;
